export class WhiteGoodsDetailModel {
    item_no: number;
    item_code: string;
    item_desc: string;
    item_category: string;
    code_active: string;
    order_no: number;
    reorder_qty: number;
    qty_ytd: number;
    qty_this_month: number;
    qty_month_1: number;
    qty_month_2: number;
    qty_month_3: number;
    qty_month_4: number;
    qty_month_5: number;
    qty_month_6: number;
    qty_month_7: number;
    qty_month_8: number;
    qty_month_9: number;
    qty_month_10: number;
    qty_month_11: number;
    qty_month_12: number;
    item_unit: string;
    item_modified_date: string;

    constructor(
        item_no: number,
        item_code: string,
        item_desc: string,
        item_category: string,
        code_active: string,
        order_no: number,
        reorder_qty: number,
        qty_ytd: number,
        qty_this_month: number,
        qty_month_1: number,
        qty_month_2: number,
        qty_month_3: number,
        qty_month_4: number,
        qty_month_5: number,
        qty_month_6: number,
        qty_month_7: number,
        qty_month_8: number,
        qty_month_9: number,
        qty_month_10: number,
        qty_month_11: number,
        qty_month_12: number,
        item_unit: string,
        item_modified_date: string
    ) {
        this.item_no = item_no;
        this.item_code = item_code;
        this.item_desc = item_desc;
        this.item_category = item_category;
        this.code_active = code_active;
        this.order_no = order_no;
        this.reorder_qty = reorder_qty;
        this.qty_ytd = qty_ytd;
        this.qty_this_month = qty_this_month;
        this.qty_month_1 = qty_month_1;
        this.qty_month_2 = qty_month_2;
        this.qty_month_3 = qty_month_3;
        this.qty_month_4 = qty_month_4;
        this.qty_month_5 = qty_month_5;
        this.qty_month_6 = qty_month_6;
        this.qty_month_7 = qty_month_7;
        this.qty_month_8 = qty_month_8;
        this.qty_month_9 = qty_month_9;
        this.qty_month_10 = qty_month_10;
        this.qty_month_11 = qty_month_11;
        this.qty_month_12 = qty_month_12;
        this.item_unit = item_unit;
        this.item_modified_date = item_modified_date;
    }
}
